<template>
    <a-form :form="form" :colon="false" @submit="handleSubmit">
      <a-row :gutter="24">
        <a-col :lg="24" :md="24" :sm="24">
          <a-form-item :label="L('是否从台湾组团参加活动?')">
            <a-radio-group v-model="detail.is_team">
              <a-radio value="1">{{ L("是") }}</a-radio>
              <a-radio value="0">{{ L("否") }}</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24" v-if="detail.is_team == 1">
        <a-col :lg="24" :md="24" :sm="24">
          <a-form-item :label="L('是否是组长?')">
            <a-radio-group v-model="detail.is_team_leader">
              <a-radio value="1">{{ L("是") }}</a-radio>
              <a-radio value="0">{{ L("否") }}</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24" v-if="detail.is_team == 1 && detail.is_team_leader == 0">
        <a-col :lg="24" :md="24" :sm="24">
          <a-form-item :label="L('组长姓名（请填写组长中文姓名）')">
            <a-input
              v-decorator="[
                'team_leader',
                {
                  initialValue: detail.team_leader,
                  rules: [{ required: true, message: L('请输入组长姓名！') }],
                },
              ]"
              @blur="(e) => onBlur('team_leader', e.target.value)"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :lg="24" :md="24" :sm="24">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit" :loading="loading">{{
                L("保存")
              }}</a-button>
              <a-button @click="preview">{{ L("简历预览") }}</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </template>
  
  
  <script>
  import { updateResume } from "@/api/me";
  import qs from "qs";
  import { checkUserInfoIntegrity } from "./util";
  export default {
    props: {
      detail: {},
    },
    data() {
      return {
        form: this.$form.createForm(this),
        loading: false,
      };
    },
  
    methods: {
      onBlur(type, value) {
        console.log(type, value);
        if (this.detail[type] === value) {
          return;
        }
  
        updateResume(
          qs.stringify({
            ...this.detail,
            [type]: value,
          })
        ).then((res) => {
          if (res._status === 1) {
            this.$message.success(this.L(res.info));
            this.$emit("refresh", "team");
            // checkUserInfoIntegrity(this.detail);
          }
        });
      },
  
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            this.loading = true;
            console.log(values);
            updateResume(
              qs.stringify({
                ...this.detail,
                ...values,
              })
            )
              .then((res) => {
                if (res._status === 1) {
                  this.$message.success(this.L(res.info));
                  this.$emit("refresh", "team");
                  checkUserInfoIntegrity(this.detail);
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
      },
  
      preview() {
        const str = window.localStorage.getItem("resume");
        if (str) {
          const resume = JSON.parse(str);
          window.open("/portal/#/resume?uuid=" + resume.uuid, "_blank");
        } else {
          this.$message.error("请先登录");
        }
      },
    },
  };
  </script>